import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { PlanoContaAgrupado } from 'src/app/admihair/api/dto/plano-conta-agrupado';

interface expandedRows {
  [key: string]: boolean;
}

@Component({
  selector: 'app-plano-contas-empresa-listar',
  templateUrl: './plano-contas-empresa-listar.component.html',
  styleUrls: ['./plano-contas-empresa-listar.component.scss']
})
export class PlanoContasEmpresaListarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = false;
  loadingRelatorio: boolean = false;
  empresaSelecionada?: Empresa;
  @ViewChild('filter') filter!: ElementRef;
  listaPlanoContasAgrupados: PlanoContaAgrupado[] = [];
  expandedRows: expandedRows = {};
  isExpanded: boolean = false;

  constructor(private planoContaEmpresaService: PlanoContaEmpresaService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }


  ngOnInit(): void {
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarPlanosContaEmpresa();
    }
  }

  listarPlanosContaEmpresa() {
    this.loading = true;
    this.planoContaEmpresaService.listarPorEmpresaAgrupado(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: PlanoContaAgrupado[]) => {
          this.listaPlanoContasAgrupados = data;
          this.loading = false;
        },
        error: (err: any) => {
          this.loading = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  excluir(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.planoContaEmpresaService.excluir(id).subscribe({
          next: () => {
            this.listarPlanosContaEmpresa();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
      }
    });
  }

  obterRelatorio() {
    this.loadingRelatorio = true;
    const empresa = this.getEmpresa();
    this.planoContaEmpresaService.obterRelatorio(empresa.id).subscribe({
      next: (data: any) => {

        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // const a = document.createElement('a');
        // a.href = url;
        // a.download = `plano_conta_empresa_${empresa.razaoSocial}.pdf`;
        // a.click();
        // a.remove();


        const pdfWindow = window.open(url, '_blank');
        // if (pdfWindow) {
        //   pdfWindow.addEventListener('load', () => pdfWindow.print());
        // }

        window.URL.revokeObjectURL(url);
        this.loadingRelatorio = false;

      },
      error: (err: any) => {
        this.loadingRelatorio = false;
        this.exibirMensagemErro(err)
      }
    })
  }

  desabilitarEditar(configuravel: boolean) {
    return configuravel === true ? false : true;
  }

  editar(id?: number) {
    this._router.navigate(["/apps/plano-conta-empresa/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id?: number) {
    this._router.navigate(["/apps/plano-conta-empresa/detalhar/" + id], { relativeTo: this._activatedRoute })
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_PLANO_CONTAS_EMPRESA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PLANO_CONTAS_EMPRESA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PLANO_CONTAS_EMPRESA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PLANO_CONTAS_EMPRESA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_PLANO_CONTAS_EMPRESA');
  }

}
